import { Github, Mail, MessageCircle } from "lucide-react";
import { useLang } from "../context/LangContext";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="border-t border-border bg-background py-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-muted-foreground">
          {t.footer.by} · {t.footer.rights}
        </p>
        <div className="flex items-center gap-4">
          <a
            href="https://github.com/PiresLab"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
            data-testid="footer-github"
          >
            <Github size={16} />
          </a>
          <a
            href="mailto:pedrolucasgag@gmail.com"
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
            data-testid="footer-email"
          >
            <Mail size={16} />
          </a>
          <a
            href="https://wa.me/5534998651977"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-foreground transition-colors duration-200"
            data-testid="footer-whatsapp"
          >
            <MessageCircle size={16} />
          </a>
        </div>
      </div>
    </footer>
  );
}
